import React, { useEffect, useState } from 'react';
import { SelectSource } from './selectSource';
import { SelectSourcePopup } from './selectSourcePopup';
import { IMainProps } from './main.types';

export function Main(props : IMainProps) {

    const { getDropboxFileData } = props;
    const [screenSize, setScreenSize] = useState('');

    function getScreenWidth(){
        if(window.navigator.userAgent.includes('Mac')){
            setScreenSize('Mac')
        }else{
            setScreenSize('Web')
        }
    }
    
    useEffect(() => {
      getScreenWidth()
    }, [screenSize])

  return (
    <div>
        {
          screenSize === 'Mac' ? <SelectSource getDropboxFileData={getDropboxFileData} /> : <SelectSourcePopup getDropboxFileData={getDropboxFileData} />
        } 

    </div>
  );
}